import type { FC } from 'react'
import FAQBottomDrawer from './FAQBottomDrawer'
import FAQModal from './FAQModal'
import useDeviceDetect from '../../hooks/useDeviceDetect'
import type { QuestionSet } from '../../types'
import getQuestionSet from './FAQ.utils'

interface FAQWrapperProps {
  open: boolean
  toggleOpen: (value: boolean) => void
  questionSet: QuestionSet
  id: string
  labelledBy: string
  describedBy: string
}

const FAQWrapper: FC<FAQWrapperProps> = ({ id, toggleOpen, questionSet, ...rest }) => {
  const { isMobile } = useDeviceDetect()
  const data = getQuestionSet(questionSet)
  return (
    <>
      {isMobile ? (
        <FAQBottomDrawer
          {...rest}
          id={`${id}-bottom-drawer`}
          data={data}
          toggleDrawerOpen={toggleOpen}
        />
      ) : (
        <FAQModal {...rest} id={`${id}-modal`} data={data} toggleModalOpen={toggleOpen} />
      )}
    </>
  )
}

export default FAQWrapper
